<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form :form="form" layout="inline">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="安装类别">
              <a-select  v-decorator="['installTypeCode']" allowClear="true" @change="handleChange">
                <a-select-option  v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单类型">
              <a-input v-model="queryParam.typeName"/>
              <!--<a-select  v-model="queryParam.typeCode" style="width: 210px;">-->
                <!--<a-select-option  v-for="type in restaurantTypes1" :key="type.code">{{type.label}}</a-select-option>-->
              <!--</a-select>-->
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="默认金额类型">
              <a-select v-decorator="['defaultPriceType']" allowClear="true">
                <a-select-option v-for="item in data1" :title="item.priceName" :key="item.id" :value="item.id">{{item.priceName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" :style="{ textAlign: 'right' }">
            <a-button type="primary" htmlType="submit" @click="handleSelect">查询</a-button>
            <a-button style="margin-left: 8px;" @click="qingkong">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider/>
    <div style="margin-bottom: 20px">
      <a-row>
        <a-col :span="5" :offset="19"  :style="{ textAlign: 'right' }">
          <a-button v-if="editEnabel" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
          <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
          <!--<a-button type="danger" icon="delete" style="width: 120px;" @click="delByIds(selectedRowKeys)">删除</a-button>-->
          <!--</a-dropdown>-->
        </a-col>
      </a-row>
    </div>
    <s-table
      size="default"
      ref="table"
      rowKey="channelId"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="typeCode" slot-scope="text, record">
      <td v-for="type in restaurantTypes1" :key="type.code" v-if="record.typeCode == type.code">{{type.label}}</td>
      </span>
      <span slot="installTypeCode" slot-scope="text, record">
         <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installTypeCode == type.code">{{type.label}}</td>
      </span>
      <span slot="isEnterpriseSee" slot-scope="text, record">
         {{conversion[text]}}
      </span>
      <span slot="action" slot-scope="text, record">
        <a v-if="queryList" @click="handleEdit(record,1)">查看</a>
        <a-divider v-if="queryList" type="vertical"/>
        <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
        <a-divider v-if="editEnabel && deleteEnabel" type="vertical"/>
        <a v-if="deleteEnabel" @click="delByIds(record.orderTypeId)">删除</a>
        <!--<a-divider type="vertical" />-->
        <!--<a v-if="record.delStatus==1" @click="showState(record.channelId,record.forbiddenStatus)">启用</a>-->
        <!--<a v-else @click="showState(record.channelId,record.forbiddenStatus)">禁用</a>-->
      </span>
    </s-table>
    <channel-modal ref="modal" @ok="handleOk"/>
  </a-card>
</template>
<script>

  import { STable } from '@/components'
  import { getOrderTypeList,getBasicPriceList,del } from '@/api/basicdatas/OrderType'
  import ChannelModal from './modules/OrdertypeModal.vue'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"

  export default {
    name: 'TableList',
    components: {
      STable,
      ChannelModal
    },
    data () {
      return {
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'num',
            width:60,
            align:'center',
          },
          {
            title: '操作',
            width:60,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
          {
            title: '安装类别',
            dataIndex: 'installTypeCode',
            scopedSlots: { customRender: 'installTypeCode' },
            align:'center',
          },
          {
            title: '订单类型',
            dataIndex: 'typeName',
            scopedSlots: { customRender: 'typeName' },
            align:'center'
          },
          {
            title: '默认金额类型',
            dataIndex: 'defaultPriceType',
            align:'center'
          },,
          {
            title: '是否企业可见',
            dataIndex: 'isEnterpriseSee',
            scopedSlots: { customRender: 'isEnterpriseSee' },
            align:'center'
          },
        ],
        conversion:{
          0:'是',
          1:'否',
        },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return getOrderTypeList(Object.assign(parameter, this.queryParam))
        },
        data:[],
        data1:[],
        restaurantTypes: [],
        editEnabel: checkPermission('basicdata:OrderType:edit'),
        queryList: checkPermission('basicdata:OrderType:query'),
        deleteEnabel: checkPermission('basicdata:OrderType:delete')
      }
    },
    async created () {
      // document.body.addEventListener('keyup', e => {
      //   if (e.keyCode == 13) {
      //     this.handleSelect()
      //   }
      // })
      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
    },
    // destroyed () {
    //   document.body.removeEventListener('keyup', e => {})
    // },
    methods: {
      handleSelect(){
        this.queryParam.installTypeCode=this.form.getFieldValue('installTypeCode')
        this.queryParam.defaultPriceType=this.form.getFieldValue('defaultPriceType')
        this.$refs.table.refresh(true)
      },
      qingkong(){
        this.data = []
        this.form.resetFields()
        this.queryParam={};
      },
      handleChange (value) {
        this.data1 = []
        this.form.setFieldsValue({defaultPriceType:undefined})
        getBasicPriceList({installationType:value}).then(res=>{
          // console.log(res)
          this.data1=res.rows
        })
      },
      showState (channelId, forbiddenStatus) {
        if (forbiddenStatus == 0) {
          forbiddenBrand({ 'channelId': channelId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (forbiddenStatus == 1) {
          enableChannel({ 'channelId': channelId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('启动成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      handleAdd () {
        this.$refs.modal.add()
      },
      handleEdit (record,status) {
        // console.log(record)
        this.$refs.modal.edit(record,status)
      },
      handleOk (value) {
        if(value == 1){
          this.$refs.table.refresh(true)
        }else{
          this.$refs.table.refresh()
        }
      },
      delByIds (orderTypeId) {
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            del({ 'orderTypeId': orderTypeId }).then(res => {
              if (res.code === 0) {
                if(res.data == '不可删除'){
                  that.$message.error('本条数据被引用无法删除')
                }else{
                  that.$message.success('删除成功')
                  that.handleOk()
                }
              } else {
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }
    },
    watch: {
      /*
          'selectedRows': function (selectedRows) {
            this.needTotalList = this.needTotalList.map(item => {
              return {
                ...item,
                total: selectedRows.reduce( (sum, val) => {
                  return sum + val[item.dataIndex]
                }, 0)
              }
            })
          }
          */
    }
  }
</script><style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;padding: 4px 16px;}
  /deep/ .ant-table-content{
    width:60%
  }
</style>
